import { render, staticRenderFns } from "./demolist.vue?vue&type=template&id=09eeac4f"
import script from "./demolist.vue?vue&type=script&lang=js"
export * from "./demolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports